import { getClientTimeOffset } from "./utils";

export type IAccessToken = string;

export interface IAuthState {
  accessToken: IAccessToken;
  clientTimeOffsetMs: number;
}

export const AUTH_TOKEN_UPDATE_FULFILLED = "AUTH_TOKEN_UPDATE_FULFILLED";
export const putAuthTokenUpdateFulfilled = (accessToken: IAccessToken) => ({
  type: AUTH_TOKEN_UPDATE_FULFILLED,
  payload: accessToken,
});

const defaultState: IAuthState = {
  accessToken: null,
  clientTimeOffsetMs: null,
};

export default function reducer(
  state: IAuthState = defaultState,
  action: IAction<any>,
): IAuthState {
  switch (action.type) {
    case AUTH_TOKEN_UPDATE_FULFILLED:
      return {
        ...state,
        accessToken: action.payload,
        clientTimeOffsetMs: getClientTimeOffset(action.payload),
      };
    default:
      return state;
  }
}
